import { Metric } from '../../../../dashboard-config/dashboard-config.model';
import {
  expandProductCatalog,
  ProductCatalogEntry,
} from '../../../_shared/dashboard-definition.model';
import { createDashboardComparisonStructureDefinition } from './create-dashboard-comparison-structure-definition';
import {
  ComparisonStructureMetricProfile,
  comparisonStructureCompaniesCountProfile,
  comparisonStructureCompaniesRevenueProfile,
  comparisonStructureGrossValueAddedProfile,
  comparisonStructureEconomicParticipantProfile,
} from './dashboard-comparison-structure-metric.profile';
import { DashboardComparisonStructureShell } from './dashboard-comparison-structure-shell.profile';
import { DashboardComparisonStructureDefinition } from './dashboard-comparison-structure.definition';

/**
 * Product catalog for national comparison structure (districts dual A/B).
 * Employed districts stays a bespoke shell package outside this catalog.
 * Identity is derived in {@link createDashboardComparisonStructureDefinition}.
 */

type ComparisonStructureMetric =
  | Metric.CompaniesCount
  | Metric.CompaniesRevenue
  | Metric.GrossValueAdded
  | Metric.EconomicParticipant;

export const COMPARISON_STRUCTURE_PRODUCT_CATALOG: Record<
  ComparisonStructureMetric,
  ProductCatalogEntry<
    ComparisonStructureMetricProfile,
    DashboardComparisonStructureShell
  >
> = {
  [Metric.CompaniesCount]: {
    metric: comparisonStructureCompaniesCountProfile,
    shells: ['districts'],
  },
  [Metric.CompaniesRevenue]: {
    metric: comparisonStructureCompaniesRevenueProfile,
    shells: ['districts'],
  },
  [Metric.GrossValueAdded]: {
    metric: comparisonStructureGrossValueAddedProfile,
    shells: ['districts'],
  },
  [Metric.EconomicParticipant]: {
    metric: comparisonStructureEconomicParticipantProfile,
    shells: ['districts'],
  },
};

/** National comparison structure products (districts dual A/B). */
export const COMPARISON_STRUCTURE_DEFINITIONS: DashboardComparisonStructureDefinition[] =
  expandProductCatalog(
    Object.values(COMPARISON_STRUCTURE_PRODUCT_CATALOG),
    createDashboardComparisonStructureDefinition,
  );
